var exports = {
  "s": "mergeabilityIcon__Yj-Tr6",
};

module.exports = exports;
